import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const LoginStore = create((set) => ({
    isLoggedIn: false,
    userData: null,

    checkIsLoggedIn: (successCallback, errorCallback) => {
        const payload = {};
        const url = AppConfig.HOST_URL + 'login/isLoggedIn';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                let isLoggedIn =
                    null != data.isLoggedIn ? data.isLoggedIn : false;

                set((state) => ({ userData: data, isLoggedIn: isLoggedIn }));
            },
            successCallback,
            errorCallback,
        );
    },

    checkCredentials: (username, password, successCallback, errorCallback) => {
        set((state) => ({ userData: null, isLoggedIn: false }));

        const payload = { username: username, password: password };
        const url = AppConfig.HOST_URL + 'login/authenticate';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({
                    userData: data.user,
                    isLoggedIn: data.isLoggedIn,
                }));
            },
            successCallback,
            errorCallback,
        );
    },

    logout: (successCallback, errorCallback) => {
        const payload = {};
        const url = AppConfig.HOST_URL + 'login/logout';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ userData: null, isLoggedIn: false }));
            },
            successCallback,
            errorCallback,
        );
    },
}));

export default LoginStore;
